const SubscriptionsTabLayout = ({filters, summary, table}) =>{
    return (
        <div>
            {filters}
            {summary}
            {table}
        </div>
    );
}

export default SubscriptionsTabLayout;